/** Milliseconds until the next minute boundary, or the next second boundary when seconds are shown. */
export function msUntilNextTick(nowMs: number, seconds: boolean): number {
  const step = seconds ? 1000 : 60_000;
  return step - (nowMs % step);
}
